import styled from 'styled-components';
import { THEME } from '@/common/styles/theme';

export const DiscoverBackButtonRoot = styled.button`
	position: absolute;
	top: calc(env(safe-area-inset-top, 0px) + 14px);
	left: 18px;
	z-index: 25;
	width: 42px;
	height: 42px;
	border: 1px solid rgba(255, 255, 255, 0.16);
	border-radius: 50%;
	display: none;
	place-items: center;
	color: #fff;
	background: rgba(8, 7, 10, 0.58);
	backdrop-filter: blur(14px);
	box-shadow: 0 8px 24px rgba(0, 0, 0, 0.38);
	cursor: pointer;
	transition:
		background 160ms ease,
		border-color 160ms ease,
		transform 160ms ease;

	&:hover,
	&:focus-visible {
		background: rgba(18, 14, 22, 0.78);
		border-color: rgba(255, 162, 241, 0.42);
		transform: translateY(-1px);
	}

	@media (max-width: ${THEME.mobileBreakpoint}) {
		display: grid;
	}
`;
